import { render, staticRenderFns } from "./MDatatable.vue?vue&type=template&id=362e2a0b"
import script from "./MDatatable.vue?vue&type=script&lang=js"
export * from "./MDatatable.vue?vue&type=script&lang=js"
import style0 from "./MDatatable.vue?vue&type=style&index=0&id=362e2a0b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f8be560a05ba39e4779a4b3800f88bf1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports